module.exports = __webpack_public_path__ + "img/sweden.6413fcd6.png";